import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithAuth } from "../baseQuery";

export interface UserResponse {
  central: {
    _id?: string;
    name: string;
    login: string;
    password: string;
    logoBase64String: string;
    logoExtension: string;
    logo: string;
  };
}
export interface Account {
  accessToken: string;
  central: {
    _id?: string;
    name: string;
    login: string;
    password: string;
    logoBase64String: string;
    logoExtension: string;
    logo: string;
  };
}

export interface LoginRequest {
  login: string;
  password: string;
}

export const accountSlice = createApi({
  reducerPath: "account",
  baseQuery: baseQueryWithAuth("central"),
  tagTypes: ["Account"],
  endpoints(builder) {
    return {
      login: builder.mutation<UserResponse, LoginRequest>({
        query: (credentials) => ({
          url: "/login",
          method: "POST",
          body: credentials,
        }),
      }),
    };
  },
});

export const {
  useLoginMutation,
} = accountSlice;
